// extracted by mini-css-extract-plugin
export default {"IconLink":"IconLink_IconLink__ScHOk","IconLink__Name":"IconLink_IconLink__Name__uGg4C","spin":"IconLink_spin__fee+R"};